<template>
  <div>
    <top />
    <div class="main home">
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span class="fl" style="line-height: 46px;margin-left:20px;">当前位置：</span>
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>公司新闻</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 新闻列表 -->
      <ul class="lists" v-loading="loading">
        <li class="clearfix" v-for="ele in newsList.list" :key="ele.id">
          <img class="fl" v-if="ele.imgSrc" :src="baseurl+'/ms/file/getimage/'+ele.imgSrc[0]" alt />
          <img v-else :src="require('@/assets/images/default_img.png')" alt="">
          <div class="fr list">
            <div class="clearfix">
              <h1 class="fl">
                <router-link
                  class="title"
                  :to="{path:'/detail',query:{id:ele.id}}"
                  target="_blank"
                  :title="ele.contentTitle"
                >{{ele.contentTitle}}</router-link>
              </h1>
              <span class="fr">{{ele.contentDatetime.slice(0,10)}}</span>
            </div>
            <p>{{ele.contentDetailsCN.slice(0,100)}}...</p>
            <router-link
              class="fr ellipsis"
              :to="{path:'/detail',query:{id:ele.id}}"
              target="_blank"
              :title="ele.contentTitle"
            >查看详情</router-link>
          </div>
        </li>
      </ul>
      <el-empty v-show="!newsList.total && !loading " :image-size="150" description="暂无数据"></el-empty>
      <div class="clearfix">
        <el-pagination
          v-show="newsList.total"
          @current-change="handleCurrentChange"
          :current-page="newsList.pageNum"
          :page-size="5"
          prev-text="上一页"
          next-text="下一页"
          layout="total, prev, pager, next, jumper"
          :total="newsList.total"
        ></el-pagination>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      baseurl: window.baseurl,
      newsList: {},
      currentPage: 1,
      total: 0
    };
  },
  created() {
    this.loadNews();
  },
  // watch: {
  //   $route: {
  //     handler(to) {
  //       this.param = to.query.param;
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    // 公司新闻
    async loadNews() {
      this.loading = true;
      const { code, data } = await this.$api.get(
        "/cmsfront/IndexController/docListByMenuId",
        {
          menuId: "1498110650348503042",
          pageNum: this.currentPage,
          pageSize: 5
        }
      );
      if (code === 0) {
        this.loading = false;
        this.newsList = data;
        this.currentPage = data.pageNum;
        this.total = data.total;
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadNews();
    }
  }
};
</script>

<style lang='scss' scoped>
.main {
  position: relative;
  .el-breadcrumb {
    background: #f3f5f7;
    margin-top: 30px;
  }
  .el-breadcrumb__item {
    line-height: 40px;
  }
  .lists {
    min-height: 600px;
    padding: 0%;
    padding-left: 16px;
    padding-top: 20px;
    li {
      padding: 36px 0px;
      img {
        width: 187px;
        height: 126px;
      }
      .list {
        width: 950px;
        h1 {
          .title {
            display: block;
            color: #333333;
            line-height: 24px;
            font-size: 16px;
            font-weight: 400;
            &:hover {
              color: #0d4f93;
            }
          }
        }
        span {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
        }
        p {
          font-size: 14px;
          color: #b7b6b2;
          line-height: 24px;
        }
        .ellipsis {
          width: 78px;
          height: 25px;
          background: #77a3cf;
          font-size: 12px;
          color: #ffffff;
          line-height: 23px;
          text-align: center;
          margin-top: 24px;
          &:hover {
            font-weight: 700;
            background: #0d4f93;
          }
        }
      }
    }
  }
  .el-empty {
    padding: 100px 0;
  }
}
.el-pagination {
  float: right;
  padding: 54px 0 90px;
}
</style>